import { render } from "./DocumentManagement.vue?vue&type=template&id=2ece8782&scoped=true"
import script from "./DocumentManagement.vue?vue&type=script&language=ts&lang=js"
export * from "./DocumentManagement.vue?vue&type=script&language=ts&lang=js"

import "./DocumentManagement.vue?vue&type=style&index=0&id=2ece8782&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ece8782"

export default script